const USER_ROLES = [
  {
    value: 'editor',
    label: 'Editor',
  },
  {
    value: 'writer',
    label: 'Writer',
  },
  {
    value: 'customer',
    label: 'Customer',
  },
  {
    value: 'developmentalEditor',
    label: 'Developmental Editor',
  },
  {
    value: 'admin',
    label: 'Admin',
  },
  {
    value: 'contentTeam',
    label: 'Content Team',
  },
  {
    value: 'proProofreader',
    label: 'Pro Proofreader',
  },
];

module.exports = USER_ROLES;
